// extracted by mini-css-extract-plugin
export default {"coinContainer":"Landing_coinContainer__nSnZv","input":"Landing_input__oChjY"};